export const ChannelLightning = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.60749 14.3901H6.07333C5.61191 14.3901 5.29362 13.9283 5.45781 13.4974L8.96959 4.27957C9.0171 4.15486 9.10137 4.04753 9.21125 3.97179C9.32113 3.89605 9.45143 3.85549 9.58488 3.85547H15.5109C15.9784 3.85547 16.2972 4.32918 16.1207 4.76228L14.0759 9.78123H17.9253C18.4914 9.78123 18.7935 10.4486 18.4201 10.874L8.98232 21.6279C8.52354 22.1508 7.67292 21.6977 7.85095 21.0254L9.60749 14.3901Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
